var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 99 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3283 2.67266L39.46 2.35818L38.7882 2.99176L4.35737 35.4646L2.69761 37.0299L4.79266 37.9332L48.2534 56.6717L49.1286 57.049L49.8419 56.4171L77.6057 31.8237L82.5582 59.9108L82.8187 61.388L84.2959 61.1275L95.4233 59.1655L96.9005 58.905L96.64 57.4278L90.3191 21.5799L90.1684 20.7255L89.3527 20.43L40.3283 2.67266ZM18.0346 45.6635L15.5093 44.6185L15.9838 47.31L20.4988 72.9156L20.6657 73.862L21.5951 74.106L52.9805 82.3459L53.7137 82.5384L54.3035 82.0623L79.413 61.7938L80.1018 61.2378L79.9481 60.3661L75.7866 36.7652L75.3009 34.0104L73.275 35.9393L49.4216 58.6516L18.0346 45.6635Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.0bc51fa590873374b0f46603bc648d63.svg";
export { ForwardRef as ReactComponent };